/** Filter types whose content (e.g. calendar popover, slider) must overflow the lightbox panel */
export const OVERFLOW_VISIBLE_FILTER_TYPES = new Set(["dateRangeType", "numberRangeType"]);

/** Semantic alias — range filter types that need special rendering (inline panel instead of lightbox) */
export const RANGE_FILTER_TYPES = OVERFLOW_VISIBLE_FILTER_TYPES;

/**
 * Check whether a filter value is non-empty.
 * Handles both array values (multiselect, dateRange) and
 * object values (numberRange: { min, max }).
 */
export const hasFilterValue = (v) => {
  if (v == null) return false;
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === 'object') return Object.keys(v).length > 0;
  return false;
};
